import { useNavigate, useParams } from "react-router-dom";
import { useModules } from "@/auth/ModulesContext";
import { useApAccountingSettings } from "@/hooks/useAccountingConnected";
import { SupplierCreditNotePage as SupplierCreditNotePageView } from "@/components/SupplierCreditNotePage";

export function SupplierCreditNotePage() {
  const navigate = useNavigate();
  const { hasModule, modules } = useModules();
  const accountingConnected = useApAccountingSettings(modules !== null && hasModule("ap.accounting")) !== null;
  const { creditNoteId } = useParams<{ creditNoteId: string }>();

  return (
    <SupplierCreditNotePageView
      accountingConnected={accountingConnected}
      creditNoteId={creditNoteId!}
      onBack={() => navigate("/supplier-credit-notes")}
      onSupplierClick={(id) => navigate(`/suppliers/${id}`)}
      onBillClick={(id) => navigate(`/bills/${id}`)}
    />
  );
}
